"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Returns a string representation of the type which also differentiates between 'object' and 'array'
 *
 * @category Lang
 * @param {*} value - The value to check
 * @returns {string} - array, object, string, number, boolean, function...
 * @example
 * typeOf({})             // returns 'object'
 * typeOf([])             // returns 'array'
 * typeOf('Hello world')  // returns 'string'
 * typeOf(7)              // returns 'number'
 * typeOf(true)           // returns 'boolean'
 * typeOf(() => {})       // returns 'function'
 */
var _default = function _default(value) {
  return Array.isArray(value) ? 'array' : _typeof(value);
};

exports.default = _default;